import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetSpaceCapacityWindowsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.SpaceCapacityWindowDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.SpaceCapacityWindowDocumentSortInput> | Types.SpaceCapacityWindowDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetSpaceCapacityWindowsQuery = { __typename?: 'Query', spaceCapacityWindows?: { __typename?: 'SpaceCapacityWindowsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SpaceCapacityWindowDocument', id: string, siteLocationId: string, subLocationId: string, spaceTypeId: string, year?: number | null, startWeek: number, endWeek: number, amount: number, reliefFraction: number, notes?: string | null, updated: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type SpaceCapacityWindowFieldsFragment = { __typename?: 'SpaceCapacityWindowDocument', id: string, siteLocationId: string, subLocationId: string, spaceTypeId: string, year?: number | null, startWeek: number, endWeek: number, amount: number, reliefFraction: number, notes?: string | null, updated: Types.TDateISO };

export type GetSpaceTypeCapacitiesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.SpaceTypeCapacityDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.SpaceTypeCapacityDocumentSortInput> | Types.SpaceTypeCapacityDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetSpaceTypeCapacitiesQuery = { __typename?: 'Query', spaceTypeCapacities?: { __typename?: 'SpaceTypeCapacitiesConnection', totalCount: number, nodes?: Array<{ __typename?: 'SpaceTypeCapacityDocument', id: string, siteLocationId: string, subLocationId: string, spaceTypeId: string, amount: number, updated: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type SpaceTypeCapacityFieldsFragment = { __typename?: 'SpaceTypeCapacityDocument', id: string, siteLocationId: string, subLocationId: string, spaceTypeId: string, amount: number, updated: Types.TDateISO };

export const SpaceCapacityWindowFieldsFragmentDoc = new TypedDocumentString(`
    fragment SpaceCapacityWindowFields on SpaceCapacityWindowDocument {
  id
  siteLocationId
  subLocationId
  spaceTypeId
  year
  startWeek
  endWeek
  amount
  reliefFraction
  notes
  updated
}
    `, {"fragmentName":"SpaceCapacityWindowFields"});
export const SpaceTypeCapacityFieldsFragmentDoc = new TypedDocumentString(`
    fragment SpaceTypeCapacityFields on SpaceTypeCapacityDocument {
  id
  siteLocationId
  subLocationId
  spaceTypeId
  amount
  updated
}
    `, {"fragmentName":"SpaceTypeCapacityFields"});
export const GetSpaceCapacityWindowsDocument = new TypedDocumentString(`
    query GetSpaceCapacityWindows($where: SpaceCapacityWindowDocumentFilterInput, $order: [SpaceCapacityWindowDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  spaceCapacityWindows(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...SpaceCapacityWindowFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment SpaceCapacityWindowFields on SpaceCapacityWindowDocument {
  id
  siteLocationId
  subLocationId
  spaceTypeId
  year
  startWeek
  endWeek
  amount
  reliefFraction
  notes
  updated
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetSpaceTypeCapacitiesDocument = new TypedDocumentString(`
    query GetSpaceTypeCapacities($where: SpaceTypeCapacityDocumentFilterInput, $order: [SpaceTypeCapacityDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  spaceTypeCapacities(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...SpaceTypeCapacityFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment SpaceTypeCapacityFields on SpaceTypeCapacityDocument {
  id
  siteLocationId
  subLocationId
  spaceTypeId
  amount
  updated
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetSpaceCapacityWindows: build.query<GetSpaceCapacityWindowsQuery, GetSpaceCapacityWindowsQueryVariables | void>({
      query: (variables) => ({ document: GetSpaceCapacityWindowsDocument, variables })
    }),
    GetSpaceTypeCapacities: build.query<GetSpaceTypeCapacitiesQuery, GetSpaceTypeCapacitiesQueryVariables | void>({
      query: (variables) => ({ document: GetSpaceTypeCapacitiesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetSpaceCapacityWindowsQuery, useLazyGetSpaceCapacityWindowsQuery, useGetSpaceTypeCapacitiesQuery, useLazyGetSpaceTypeCapacitiesQuery } = injectedRtkApi;
